import { HotelSearchRequest } from '@/__generated';
import SearchBox from '@/components/App/SearchBox/SearchBox';
import { SearchBoxBackgroundImage } from '@/config';
import { faChevronUp, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useWindowSize } from '@uidotdev/usehooks';
import React from 'react';
import { Collapse } from 'reactstrap';

type Props = {
  onSearchHotel: (request: HotelSearchRequest) => void;
  loading?: boolean;
};
const MAX_WIDTH_DISPLAY_SEARCHBOX = 1200;

export default function SearchBoxHotelSearch({ onSearchHotel, loading }: Props) {
  const [stickyHeader, setHeaderSticky] = React.useState(false);
  const [isOpen, setIsOpen] = React.useState(false);
  const { width } = useWindowSize();
  const toggle = () => setIsOpen(!isOpen);
  const changeBackground = () => {
    if (width && width > MAX_WIDTH_DISPLAY_SEARCHBOX) {
      if (window.scrollY >= 60) {
        setHeaderSticky(true);
      } else {
        setHeaderSticky(false);
      }
    } else {
      setHeaderSticky(false);
    }
  };

  React.useEffect(() => {
    window.addEventListener('scroll', changeBackground);
    window.addEventListener('resize', changeBackground);

    return () => {
      window.removeEventListener('scroll', changeBackground);
      window.removeEventListener('resize', changeBackground);
    };
  }, [width]);
  if (width && width < MAX_WIDTH_DISPLAY_SEARCHBOX) {
    return (
      <>
        <div className=" py-10 bg-dark-1 text-center text-white" onClick={toggle}>
          {isOpen ? (
            <>
              Hide search box
              <FontAwesomeIcon icon={faChevronUp} className="ml-15" />
            </>
          ) : (
            <>
              {' '}
              Show search box
              <FontAwesomeIcon icon={faChevronDown} className="ml-15" />
            </>
          )}
        </div>
        <Collapse isOpen={isOpen}>
          <div className={`transition-cubic d-block bg-dark-2 ${stickyHeader ? 'singleMenu js-singleMenu -is-active' : ''}`}>
            <section className="pt-10 pb-10  masthead -type-1 z-5">
              <div className="container">
                <div className="row">
                  <div className="col-12">
                    <div className="mainSearch  bg-white px-10 py-10 lg:px-20 lg:pt-5 lg:pb-20 rounded-4">
                      <SearchBox onSearchHotel={onSearchHotel} loading={loading} height="h-50" />
                    </div>
                  </div>
                  {/* End col-12 */}
                </div>
              </div>
            </section>
          </div>
        </Collapse>
      </>
    );
  }
  return (
    <div className={`transition-cubic d-block bg-dark-2 ${stickyHeader ? 'singleMenu js-singleMenu -is-active' : ''}`}>
      <section className="pt-10 pb-10  masthead -type-1 z-5">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="mainSearch  bg-white px-10 py-10 lg:px-20 lg:pt-5 lg:pb-20 rounded-4">
                <SearchBox onSearchHotel={onSearchHotel} loading={loading} height="h-50" />
              </div>
            </div>
            {/* End col-12 */}
          </div>
        </div>
      </section>
    </div>
  );
}
